/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { IWorkFlowProtocol } from 'app/shared/model/work-flow-protocol.model';

export interface IWorkFlowProtocolLog {
  id?: string;
  encounterId?: string;
  notes?: string | null;
  completedById?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  encounterType?: IClinicalDictionary | null;
  protocol?: IWorkFlowProtocol | null;
  completedByType?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<IWorkFlowProtocolLog> = {
  active: false,
};
